import { FileText, CheckCircle2, Clock, Coins, XCircle, Pencil } from 'lucide-react';
import type { EstimateStats } from '../../shared/types/estimate.types';
import { KpiGrid, type KpiItem } from '@/components/ui/KpiGrid';

interface EstimatesKpiProps {
  stats: EstimateStats | undefined;
  isLoading?: boolean;
}

export function EstimatesKpi({ stats, isLoading }: EstimatesKpiProps) {
  const kpis: KpiItem[] = [
    {
      title: 'Tổng hồ sơ',
      value: stats?.total || 0,
      suffix: 'Hồ sơ',
      icon: FileText,
      color: 'text-blue-600',
      bg: 'bg-blue-50',
      trend: 'neutral',
      trendValue: 'Tổng quan',
      chartColor: 'bg-blue-500',
      chartData: [20, 22, 24, 25, stats?.total || 26]
    },
    {
      title: 'Đang soạn thảo',
      value: (stats as any)?.draft || 0,
      suffix: 'Hồ sơ',
      icon: Pencil,
      color: 'text-slate-600',
      bg: 'bg-slate-50',
      trend: 'neutral',
      trendValue: 'Bản nháp',
      chartColor: 'bg-slate-500',
      chartData: [5, 4, 3, 2, (stats as any)?.draft || 1]
    },
    {
      title: 'Đang duyệt',
      value: stats?.reviewing || 0,
      suffix: 'Hồ sơ',
      icon: Clock,
      color: 'text-amber-600',
      bg: 'bg-amber-50',
      trend: 'up',
      trendValue: 'Chờ duyệt',
      chartColor: 'bg-amber-500',
      chartData: [5, 6, 8, 7, stats?.reviewing || 7]
    },
    {
      title: 'Đã duyệt',
      value: stats?.approved || 0,
      suffix: 'Hồ sơ',
      icon: CheckCircle2,
      color: 'text-emerald-600',
      bg: 'bg-emerald-50',
      trend: 'up',
      trendValue: 'Sẵn sàng',
      chartColor: 'bg-emerald-500',
      chartData: [10, 12, 15, 18, stats?.approved || 20]
    },
    {
      title: 'Từ chối',
      value: (stats as any)?.rejected || 0,
      suffix: 'Hồ sơ',
      icon: XCircle,
      color: 'text-rose-600',
      bg: 'bg-rose-50',
      trend: 'down',
      trendValue: 'Lỗi',
      chartColor: 'bg-rose-500',
      chartData: [1, 2, 0, 1, (stats as any)?.rejected || 0]
    },
    {
      title: 'Giá trị dự toán',
      value: stats?.totalAmount || 0,
      suffix: 'VNĐ',
      icon: Coins,
      color: 'text-purple-600',
      bg: 'bg-purple-50',
      trend: 'up',
      trendValue: 'Tổng giá trị',
      chartColor: 'bg-purple-500',
      chartData: [100, 120, 150, 180, stats?.totalAmount || 200]
    }
  ];

  return <KpiGrid kpis={kpis} />;
}
